import React from 'react'
import PropTypes from 'prop-types'
import ExpandableList from '../expandable-list'
import analyticsUtils from '../../../helpers/analytics-utils'
import { categories } from '../../../helpers/analytics-utils/constants'

const RadioFilter = ({
  param,
  currentValue,
  availableValues,
  buildUrl,
  valueType,
  analyticsEvent,
  analyticsEventAction,
  analyticsEventParam,
}) => {
  const items = []

  const selectHandler = value => () => {
    analyticsUtils.gaTagTracking({
      event: analyticsEvent,
      eventCategory: categories.PRODUCT_FILTER,
      eventAction: analyticsEventAction,
      eventLabel: 'Select',
      [analyticsEventParam]: value,
    })
  }

  if (currentValue) {
    // Turn off the current filter
    const calcValue = availableValues.find(v => v.slug === currentValue)
      ? availableValues.find(v => v.slug === currentValue).name
      : ''

    items.push({
      link: buildUrl({ [param]: undefined }),
      value: valueType === 'text' ? currentValue : calcValue,
      onClick: selectHandler(''),
    })
  } else {
    ;(availableValues || []).forEach(value => {
      if (valueType === 'text') {
        items.push({
          link: buildUrl({ [param]: value }),
          value,
          onClick: selectHandler(value),
        })
      } else {
        items.push({
          link: buildUrl({ [param]: value.slug }),
          value: value.name,
          onClick: selectHandler(value.slug),
        })
      }
    })
  }

  return (
    <ExpandableList
      items={items}
      size={7}
      analyticsEvent={analyticsEvent}
      analyticsEventAction={analyticsEventAction}
    />
  )
}

RadioFilter.propTypes = {
  param: PropTypes.string.isRequired,
  currentValue: PropTypes.string,
  availableValues: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        slug: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ])
  ).isRequired,
  buildUrl: PropTypes.func.isRequired,
  valueType: PropTypes.oneOf(['text', 'object']),
  analyticsEvent: PropTypes.string.isRequired,
  analyticsEventAction: PropTypes.string.isRequired,
  analyticsEventParam: PropTypes.string.isRequired,
}

RadioFilter.defaultProps = {
  valueType: 'text',
}

export default RadioFilter
